import { inject, Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { finalize, Observable, tap } from 'rxjs';
import { LoadBannerVisibility, AcknowledgeBanner } from '@layout/sso-mapping-rules-banner/store/actions/sso-mapping-rules-banner.actions';
import { SsoMappingRulesBannerService } from '@layout/sso-mapping-rules-banner/services/sso-mapping-rules-banner.service';
import { SsoMappingRulesBannerResponse } from '@layout/sso-mapping-rules-banner/models/sso-mapping-rules-banner-response';

export interface SsoMappingRulesBannerStateModel {
  showBanner?: boolean;
  loading: boolean;
}

@State<SsoMappingRulesBannerStateModel>({
  name: 'ssoMappingRulesBanner',
  defaults: {
    loading: false,
  },
})
@Injectable()
export class SsoMappingRulesBannerState {
  private readonly ssoMappingRulesBannerService = inject(SsoMappingRulesBannerService);

  @Selector()
  static showBanner(state: SsoMappingRulesBannerStateModel): boolean | undefined {
    return state.showBanner;
  }

  @Selector()
  static loading(state: SsoMappingRulesBannerStateModel): boolean {
    return state.loading;
  }

  @Action(LoadBannerVisibility)
  loadBannerVisibility(context: StateContext<SsoMappingRulesBannerStateModel>): Observable<SsoMappingRulesBannerResponse> {
    context.patchState({ loading: true });

    return this.ssoMappingRulesBannerService.getBannerVisibility().pipe(
      tap(({ shouldShowBanner }) => context.patchState({ showBanner: shouldShowBanner })),
      finalize(() => context.patchState({ loading: false }))
    );
  }

  @Action(AcknowledgeBanner)
  acknowledgeBanner(context: StateContext<SsoMappingRulesBannerStateModel>): Observable<void> {
    context.patchState({ loading: true });

    return this.ssoMappingRulesBannerService.acknowledgeBanner().pipe(
      tap(() => context.patchState({ showBanner: false })),
      finalize(() => context.patchState({ loading: false }))
    );
  }
}
